import React from 'react';

import { Link } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';

const userLinkFormatter = <Row extends { fk_customer_id: string }>(params: GridRenderCellParams<Row>) => (
  <Link href={`/users/${params.row.fk_customer_id}`} target="_blank" title={params.value}>
    {params.value}
  </Link>
);

export default userLinkFormatter;
